import { faEdit, faUndoAlt } from '@fortawesome/free-solid-svg-icons'
import { TFunction } from 'i18next'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../Authentication/Authorization'
import DialogContext from '../../Authentication/DialogContext'
import { ConfirmDialogProps } from '../../components/ConfirmDialog'
import DataTable, { CaptionButton } from '../../components/DataTable'
import { EditDialogProps } from '../../components/EditDialog'
import Loading from '../../layout/Loading'
import LoginDelayService from '../../service/LoginDelayService'
import GatewayType from '../GatewayType'

const LoginDelay: GatewayType = () => {
  const [loginDelay, setLoginDelay] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { editDialogPropsSetter, confirmDialogPropsSetter } = useContext(DialogContext)
  const { t } = useTranslation()

  useEffect(() => {
    LoginDelayService.get()
      .then((loginDelay: any[]) => setLoginDelay(loginDelay))
      .finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data =
    Object.keys(loginDelay).length > 0
      ? [
          {
            label: t('loginDelay.interval1'),
            value: loginDelay.interval1,
          },
          {
            label: t('loginDelay.interval2'),
            value: loginDelay.interval2,
          },
          {
            label: t('loginDelay.interval3'),
            value: loginDelay.interval3,
          },
        ]
      : []

  var captionButtons: CaptionButton[] = [
    {
      onClick: () => configureLoginDelayDialog(t, editDialogPropsSetter, setLoginDelay, loginDelay),
      text: t('edit'),
      icon: faEdit,
      permissions: Authorization.userManagement.passwordPolicy.edit,
    },
    {
      onClick: () => restoreDefaultDialog(t, confirmDialogPropsSetter, setLoginDelay),
      text: t('restoreDefaults'),
      icon: faUndoAlt,
      permissions: Authorization.userManagement.passwordPolicy.edit,
    },
  ]

  return (
    <Loading isLoading={loading}>
      <DataTable
        keyField='label'
        data={data}
        columns={columns}
        headerClasses='d-none'
        searchable={false}
        caption={t('loginDelay.text')}
        captionButtons={captionButtons}
      />
    </Loading>
  )
}

function configureLoginDelayDialog(t: TFunction, editDialogPropsSetter: any, setLoginDelay: React.Dispatch<any>, loginDelay: any) {
  const editDialogProps: EditDialogProps = {
    show: true,
    header: t('loginDelay.configureHeader'),
    onSubmit: LoginDelayService.update,
    onSubmitExtraArgs: [t, setLoginDelay],
    labelGridSize: 5,
    data: [
      {
        id: 'interval1',
        value: loginDelay.interval1,
        type: 'number',
        label: t('loginDelay.interval1'),
        placeholder: '0',
        required: true,
        requiredMessage: t('invalidMessage', { label: 'interval' }),
      },
      {
        id: 'interval2',
        value: loginDelay.interval2,
        type: 'number',
        label: t('loginDelay.interval2'),
        placeholder: '0',
        required: true,
        requiredMessage: t('invalidMessage', { label: 'interval' }),
      },
      {
        id: 'interval3',
        value: loginDelay.interval3,
        type: 'number',
        label: t('loginDelay.interval3'),
        placeholder: '0',
        required: true,
        requiredMessage: t('invalidMessage', { label: 'interval' }),
      },
    ],
  }

  editDialogPropsSetter(editDialogProps)
}

function restoreDefaultDialog(t: TFunction, confirmDialogPropsSetter: any, setLoginDelay: any) {
  const resetDialogProps: ConfirmDialogProps = {
    show: true,
    header: t('loginDelay.resetHeader'),
    body: t('loginDelay.resetBody'),
    submitText: t('yes'),
    onSubmit: LoginDelayService.reset,
    onSubmitExtraArgs: [t, setLoginDelay],
    cancelText: t('no'),
  }
  confirmDialogPropsSetter(resetDialogProps)
}

export default LoginDelay
